export enum VisitorsError {
  INVALID_EMAIL = 'error-invalid-email',
  DUPLICATE_EMAIL = 'error-duplicate-email',
  DUPLICATE_ORGANIZER_EMAIL = 'error-duplicate-organizer-email',
  INVALID_FIRST_NAME = 'error-invalid-first-name',
  INVALID_LAST_NAME = 'error-invalid-last-name',
  EMPTY_FIRST_NAME = 'error-empty-first-name',
  EMPTY_LAST_NAME = 'error-empty-last-name',
  EMPTY_EMAIL = 'error-empty-email',
}
